import React from "react";
import {
  ComponentProps,
  CtaProps,
  KontentRichText,
  StaffMember,
} from "../../../types";
import * as styles from "./BoardMembersGrid.module.css";
import { SectionWrapper } from "../../containers/SectionWrapper";
import { CustomRichTextElement } from "../../elements/CustomRichTextElement/CustomRichTextElement";
import { Cta } from "../../elements/Cta/Cta";
import { KontentImageElement } from "../../elements/KontentImageElement/KontentImageElement";

interface Props extends ComponentProps, CtaProps {
  id: string;
  staffMembers: StaffMember[];
  subhead: string;
  text: KontentRichText;
}

export const BoardMembersGrid: React.FC<Props> = ({
  staffMembers,
  subhead,
  text,
  ctaHref,
  ctaAriaLabel,
  ctaLabel,
  ctaTarget,
  ...props
}) => {
  const renderStaffMembers = () => {
    return staffMembers.map((member, idx) => {
      return (
        <div className={styles.staffMember} key={`staffMember-${idx}`}>
          <KontentImageElement
            image={member?.image?.item}
            alt={member?.image?.alt}
            aspectRatio={1.0}
          />
          <div className={styles.name}>
            {member?.firstName} {member?.lastName}
          </div>
          <div>{member?.appointedYear}</div>
        </div>
      );
    });
  };
  return (
    <SectionWrapper {...props}>
      <div className={styles.boardmembersgrid}>
        <div className={styles.contentContainer}>
          <div className={styles.textContainer}>
            <h2 data-kontent-element-codename="subhead">{subhead}</h2>
            {text.value !== "<p><br></p>" && (
              <CustomRichTextElement
                content={text}
                data-kontent-element-codename="text"
              />
            )}
            {ctaLabel && ctaHref && (
              <Cta
                label={ctaLabel}
                target={ctaTarget}
                href={ctaHref}
                ariaLabel={ctaAriaLabel}
                data-kontent-element-codename="link_configuration__link"
              />
            )}
          </div>
          <div
            className={styles.staffMembersContainer}
            data-kontent-element-codename="staff_members"
          >
            {renderStaffMembers()}
          </div>
        </div>
      </div>
    </SectionWrapper>
  );
};
